<template #default>
  <div class="issuer-modal">
    <a-modal
      class="page-modal"
      v-model:visible="modalVisible"
      :title="isEdit ? 'Edit Issuer' : 'Add Issuer'"
      :style="{ top: '32px', width: '900px' }"
      @ok="handleOk"
      @cancel="handleCancel"
      :confirmLoading="loading"
      destroyOnClose
    >
      <a-form
        ref="formRef"
        :model="localForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :rules="rules"
      >
        <a-card class="issuer-card" title="Basics" :bordered="false">
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-item label="Name" name="name">
                <a-input v-model:value="localForm.name" />
              </a-form-item>
            </a-col>
            <!--  <a-col :span="12">
              <a-form-item label="Short Name" name="shortName">
                <a-input v-model:value="localForm.shortName" />
              </a-form-item>
            </a-col> -->
            <a-col :span="24">
              <a-form-item label="Description" name="desc">
                <a-input v-model:value="localForm.desc" />
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="BICS Industry" name="industry">
                <a-select
                  v-model:value="localForm.industry"
                  placeholder="Select BICS industry"
                  :show-search="true"
                  :allow-clear="true"
                  :filter-option="filterBicsOption"
                >
                  <a-select-option
                    v-for="item in bicsIndustryOptions"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="GICS Industry" name="gicsIndustry">
                <a-select
                  v-model:value="gicsIndustrySelectValue"
                  placeholder="Select GICS industry"
                  :show-search="true"
                  :allow-clear="true"
                  :filter-option="filterGicsOption"
                >
                  <a-select-option
                    v-for="item in gicsIndustryOptions"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-card>

        <a-card class="issuer-card" title="Geography" :bordered="false">
          <a-row :gutter="16">
            <a-col :span="8">
              <a-form-item
                label="Domicile"
                name="countryOfDomicile"
                :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                :wrapperCol="{ span: 18 }"
              >
                <a-select
                  v-model:value="localForm.countryOfDomicile"
                  placeholder="Select country"
                  :show-search="true"
                  :allow-clear="true"
                  :filter-option="filterCountryOption"
                >
                  <a-select-option
                    v-for="item in countryList"
                    :key="item.countryCode"
                    :value="item.countryCode"
                  >
                    {{ item.countryCode }} - {{ item.countryDesc }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item
                label="Nationality"
                name="countryOfNationality"
                :labelCol="{ span: 8, style: { textAlign: 'left' } }"
                :wrapperCol="{ span: 16 }"
              >
                <a-select
                  v-model:value="localForm.countryOfNationality"
                  placeholder="Select country"
                  :show-search="true"
                  :allow-clear="true"
                  :filter-option="filterCountryOption"
                >
                  <a-select-option
                    v-for="item in countryList"
                    :key="item.countryCode"
                    :value="item.countryCode"
                  >
                    {{ item.countryCode }} - {{ item.countryDesc }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item
                label="Risk"
                name="countryOfRisk"
                :labelCol="{ span: 6, style: { textAlign: 'left' } }"
                :wrapperCol="{ span: 18 }"
              >
                <a-select
                  v-model:value="localForm.countryOfRisk"
                  placeholder="Select country"
                  :show-search="true"
                  :allow-clear="true"
                  :filter-option="filterCountryOption"
                >
                  <a-select-option
                    v-for="item in countryList"
                    :key="item.countryCode"
                    :value="item.countryCode"
                  >
                    {{ item.countryCode }} - {{ item.countryDesc }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-card>

        <a-card class="issuer-card" title="Status" :bordered="false">
          <a-row :gutter="16">
            <!-- <a-col :span="12" v-if="isEdit">
              <a-form-item label="IssuerId">
                <a-input v-model:value="localForm.issuerId" :disabled="true" />
              </a-form-item>
            </a-col> -->
            <a-col :span="12">
              <a-form-item label="Status" name="status">
                <a-select v-model:value="localForm.status" style="width: 100%">
                  <a-select-option value="A">ACTIVE</a-select-option>
                  <a-select-option value="I">INACTIVE</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-card>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import { message } from 'ant-design-vue'
import security from '@/api/security'

const props = defineProps({
  visible: { type: Boolean, required: true },
  isEdit: { type: Boolean, default: false },
  addForm: { type: Object, required: true },
})
const emit = defineEmits(['update:visible', 'update:issuer'])

const store = useStore()

const labelCol = { span: 4, style: { textAlign: 'left' } }
const wrapperCol = { span: 20 }
const formRef = ref()
const loading = ref(false)
const rules = {
  name: [{ required: true, message: 'Please input name' }],
}

const countryList = computed(() => {
  const countries = store.getters['reference/getCountryList'] || []
  return [...countries].sort((a, b) =>
    a.countryCode.localeCompare(b.countryCode)
  )
})

const filterCountryOption = (input, option) => {
  return option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

const gicsRaw = ref([])
const gicsLoaded = ref(false)
const bicsRaw = ref([])
const bicsLoaded = ref(false)

const pickFirstString = (obj, keys) => {
  if (!obj || typeof obj !== 'object') return null
  for (const key of keys) {
    const val = obj[key]
    if (typeof val === 'string' && val.trim() !== '') return val.trim()
  }
  return null
}

const normalizeGicsItems = computed(() => {
  const list = Array.isArray(gicsRaw.value) ? gicsRaw.value : []
  return list
    .map((item) => {
      if (typeof item === 'string') {
        return { industry: item, subIndustry: null }
      }
      const industry = pickFirstString(item, ['industry']) || null
      const subIndustry = pickFirstString(item, ['subIndustry']) || null
      const subIndustryCode = pickFirstString(item, ['subIndustryCode']) || null
      return { industry, subIndustry, subIndustryCode }
    })
    .filter((item) => item.industry || item.subIndustry)
})

const normalizeBicsItems = computed(() => {
  const list = Array.isArray(bicsRaw.value) ? bicsRaw.value : []
  return list
    .map((item) => {
      if (typeof item === 'string') {
        return { industry: item }
      }
      const industry = pickFirstString(item, ['sectorCode'])
      return { industry: industry || null }
    })
    .filter((item) => item.industry)
})

const bicsIndustryOptions = computed(() => {
  const values = normalizeBicsItems.value.map((i) => i.industry)
  const deduped = Array.from(new Set(values.filter(Boolean)))
  return deduped
    .sort((a, b) => a.localeCompare(b))
    .map((value) => ({ value, label: value }))
})

const gicsIndustryOptions = computed(() => {
  return normalizeGicsItems.value
    .filter((i) => i.industry)
    .map((i) => {
      const industry = i.industry
      const subIndustry = i.subIndustry
      const label = subIndustry ? `${industry} - ${subIndustry}` : `${industry}`
      return {
        value: `${industry}|||${subIndustry || ''}`,
        label,
        industry,
        subIndustry,
        subIndustryCode: i.subIndustryCode,
      }
    })
})

const filterGicsOption = (input, option) => {
  return option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

const filterBicsOption = (input, option) => {
  return option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

const gicsIndustrySelectValue = computed({
  get: () => {
    const industry = localForm.value?.gicsIndustry
    const subIndustry = localForm.value?.gicsSubIndustry
    if (!industry) return undefined
    if (subIndustry) return `${industry}|||${subIndustry}`
    const firstMatch = normalizeGicsItems.value.find(
      (item) => item.industry === industry && item.subIndustry
    )
    return firstMatch
      ? `${industry}|||${firstMatch.subIndustry}`
      : `${industry}|||`
  },
  set: (val) => {
    if (!val) {
      localForm.value.gicsIndustry = null
      localForm.value.gicsSubIndustry = null
      localForm.value.gicsSubIndustryCode = null
      return
    }
    const [industry, subIndustry] = String(val).split('|||')
    localForm.value.gicsIndustry = industry || null
    localForm.value.gicsSubIndustry = subIndustry || null
    const matched = gicsIndustryOptions.value.find((o) => o.value === val)
    localForm.value.gicsSubIndustryCode = matched?.subIndustryCode || null
  },
})

const modalVisible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val),
})

const localForm = ref(props.addForm)
watch(
  () => props.addForm,
  (newVal) => {
    localForm.value = newVal
  },
  { immediate: true }
)

const loadGicsSectors = async () => {
  if (gicsLoaded.value) return
  try {
    const resp = await security.getGicsSectors()
    const data = resp?.data
    gicsRaw.value = Array.isArray(data) ? data : data?.gicsSectors || []
    gicsLoaded.value = true
  } catch (err) {
    message.error(err?.response?.data?.message || 'Failed to load GICS sectors')
  }
}

const loadBicsSectors = async () => {
  if (bicsLoaded.value) return
  try {
    const resp = await security.getSectors()
    const data = resp?.data
    bicsRaw.value = Array.isArray(data) ? data : data?.sectors || []
    bicsLoaded.value = true
  } catch (err) {
    message.error(err?.response?.data?.message || 'Failed to load BICS sectors')
  }
}

onMounted(() => {
  loadGicsSectors()
  loadBicsSectors()
})

watch(
  () => props.visible,
  (val) => {
    if (val) {
      loadGicsSectors()
      loadBicsSectors()
    }
  }
)

const handleOk = () => {
  formRef.value
    .validate()
    .then(() => {
      loading.value = true
      const payload = { ...localForm.value }
      emit('update:issuer', payload, props.isEdit)
      loading.value = false
    })
    .catch((err) => {
      console.log('validate err', err)
    })
}

const handleCancel = () => {
  modalVisible.value = false
}
</script>

<style scoped>
.issuer-card {
  margin-bottom: 12px;
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(16, 24, 40, 0.06);
}
.issuer-card :deep(.ant-card-head-title) {
  font-weight: 600;
  letter-spacing: 0.2px;
}
.issuer-card :deep(.ant-card-body) {
  padding-top: 8px;
}
</style>
